import { Flex } from "antd";
import Footer from "../../components/footer";
import { DescriptionLegal, ListLegal, SectionTitleLegal, SubtitleLegal, TitleLegal } from "../../styled-components/legal";
import Navbar from "../../components/navbar";
import { useTranslation } from "react-i18next";

const Legal = () => {
    const { t } = useTranslation();

    return (
        <Flex vertical style={{ width: '100%', backgroundColor: '#1F1F1F', color: 'white', height: '100%', overflow: 'auto' }}>
            <Navbar legal />
            <div style={{ padding: '10px 50px', marginTop: 30 }}>
                <TitleLegal> { t('legal.1') } </TitleLegal>
                <SubtitleLegal> { t('legal.2') }  </SubtitleLegal>

                <SectionTitleLegal> { t('legal.3') } </SectionTitleLegal>
                <DescriptionLegal> { t('legal.4') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.5') } </DescriptionLegal>
                <Flex vertical gap={0}>
                    <DescriptionLegal> GRUP CARRIOT RESTAURANT SL </DescriptionLegal>
                    <DescriptionLegal> NIF: B55283832 </DescriptionLegal>
                    <DescriptionLegal> C\ Figueres 14, 17495 Palau Saverdera. </DescriptionLegal>
                </Flex>
                <DescriptionLegal> { t('legal.6') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.7') } </DescriptionLegal>
                
                <SectionTitleLegal> { t('legal.8') } </SectionTitleLegal>
                <DescriptionLegal> { t('legal.9') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.10') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.11') } </DescriptionLegal>
                <ul>
                    <ListLegal> { t('legal.12') } </ListLegal>
                    <ListLegal> { t('legal.13') } </ListLegal>
                    <ListLegal> { t('legal.14') } </ListLegal>
                    <ListLegal> { t('legal.15') } </ListLegal>
                </ul>
                
                <SectionTitleLegal> { t('legal.16')} </SectionTitleLegal>
                <DescriptionLegal> { t('legal.17') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.18') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.19') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.20') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.21') } </DescriptionLegal>

                <SectionTitleLegal> { t('legal.22') } </SectionTitleLegal>
                
                <DescriptionLegal> { t('legal.23') } </DescriptionLegal>

                <SectionTitleLegal> { t('legal.24') } </SectionTitleLegal>
                
                <DescriptionLegal> { t('legal.25') } </DescriptionLegal>

                <SectionTitleLegal> { t('legal.26') } </SectionTitleLegal>
                <DescriptionLegal> { t('legal.27') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.28') } </DescriptionLegal>

                <SectionTitleLegal> { t('legal.29') } </SectionTitleLegal>
                <DescriptionLegal> { t('legal.30') } </DescriptionLegal>
                
                <SectionTitleLegal> { t('legal.31') } </SectionTitleLegal>

                <SectionTitleLegal> { t('legal.32') } </SectionTitleLegal>
                
                <DescriptionLegal> { t('legal.33') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.34') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.35') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.36') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.37') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.38') } </DescriptionLegal>

                <ul>
                    <ListLegal> { t('legal.39') } </ListLegal>
                    <ListLegal> { t('legal.40') } </ListLegal>
                    <ListLegal> { t('legal.41')} </ListLegal>
                    <ListLegal> { t('legal.42') } </ListLegal>
                </ul>
                
                <DescriptionLegal> { t('legal.43') }.</DescriptionLegal>

                <DescriptionLegal> { t('legal.44') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.45') } </DescriptionLegal>

                <SectionTitleLegal> { t('legal.46') } </SectionTitleLegal>
                
                <DescriptionLegal> { t('legal.47') } </DescriptionLegal>

                <ul>
                    <ListLegal> { t('legal.48') } </ListLegal>
                    <ListLegal> { t('legal.49') } </ListLegal>
                    <ListLegal> { t('legal.50' ) } </ListLegal>
                    <ListLegal> { t('legal.51') } </ListLegal>
                </ul>

                <SectionTitleLegal> { t('legal.52') } </SectionTitleLegal>
                
                <DescriptionLegal> { t('legal.53') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.54') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.55') } </DescriptionLegal>

                <SectionTitleLegal> { t('legal.56') } </SectionTitleLegal>
                <DescriptionLegal> { t('legal.57') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.58') } </DescriptionLegal>

                <DescriptionLegal> { t('legal.59') } </DescriptionLegal>
            </div>
            <Footer />
        </Flex>
    );
}

export default Legal;